<template>
    <div>
        <PageLabel class="my-0" :label="$t('Просмотр файла')" v-if="$vuetify.breakpoint.smAndUp" />
        <v-row class="page-container mb-3 px-0 mt-4 hidden-sm-and-up">
            <h4 class="textColor fs-16">{{ $t('Передача показаний') }}</h4>
        </v-row>
        <v-row class="page-container px-0 mt-4 hidden-sm-and-up">
            <h5 class="textColor fs-14">{{ $t('Просмотр файла') }}</h5>
        </v-row>
        <div class="pb-6">
            <v-container fluid class="px-0">
                <v-row v-if="uploadsDetailTranslated">
                    <v-col cols="12" sm="6">
                        <v-row>
                            <v-col class="py-0" cols="12">
                                <strong class="mr-2">{{ $t('Дата загрузки') }}:</strong>
                                {{ uploadsDetailTranslated.load_date | formatDateFull }}
                            </v-col>
                            <v-col class="py-0" cols="12">
                                <strong class="mr-2">{{ $t('Дата отработки') }}:</strong>
                                {{ uploadsDetailTranslated.status_date | formatDateFull }}
                            </v-col>
                            <v-col class="py-0" cols="12">
                                <strong class="mr-2">{{ $t('Пользователь') }}:</strong>
                                {{ uploadsDetailTranslated.user_data_name }}
                            </v-col>
                            <v-col class="py-0" cols="12"></v-col>
                            <v-col v-if="uploadsDetailTranslated.status_name" class="py-0" :cols="12">
                                <strong class="mr-2">{{ $t('Статус') }}:</strong>
                                <span :class="{ 'error-cell': isErrorCell(uploadsDetailTranslated.status_name) }">
                                    {{ uploadsDetailTranslated.status_name.name }}
                                </span>
                            </v-col>
                        </v-row>
                    </v-col>
                    <!-- <v-col>
                    <v-row justify-md="end" justify-sm="end">
                        <v-btn
                            v-if="status === 'Загружен' && userPermissions.includes('cancelUpload')"
                            outlined
                            color="info"
                            class="mx-2 my-1 py-5 rounded-btn"
                            @click="cancelUploading"
                        >
                            <v-icon class="mr-1">mdi-file-remove-outline</v-icon>
                            {{ $t('Отменить загрузку') }}
                        </v-btn>
                        <v-btn
                            :disabled="!isUploadButtonActive"
                            color="info"
                            class="py-5 rounded-btn mx-2 my-1"
                            v-if="status === 'Загружен' && userPermissions.includes('processFile')"
                            @click="sendToProcess"
                        >
                            <v-icon class="mr-1">mdi-file-upload-outline</v-icon>
                            {{ $t('Отправить в обработку') }}
                        </v-btn>
                    </v-row>
                    </v-col>-->

                    <v-col>
                        <v-row justify-md="end" justify-sm="end" :class="{ 'px-2': $vuetify.breakpoint.xsOnly }">
                            <v-btn
                                v-if="status === 'Загружен' && userPermissions.includes('cancelUpload')"
                                outlined
                                color="info"
                                :class="{ 'rounded-btn py-5  my-1': true, 'mx-2 my-1': $vuetify.breakpoint.mdAndUp, w100: $vuetify.breakpoint.xsOnly }"
                                @click="cancelUploading"
                            >
                                <v-icon class="mr-1">mdi-file-remove-outline</v-icon>
                                {{ $t('Отменить загрузку') }}
                            </v-btn>
                            <v-btn
                                :disabled="!isUploadButtonActive"
                                color="info"
                                :class="{ 'rounded-btn py-5 my-1': true, 'mx-2 my-1': $vuetify.breakpoint.mdAndUp, w100: $vuetify.breakpoint.xsOnly }"
                                v-if="status === 'Загружен' && userPermissions.includes('processFile')"
                                @click="sendToProcess"
                            >
                                <v-icon class="mr-1">mdi-file-upload-outline</v-icon>
                                {{ $t('Отправить в обработку') }}
                            </v-btn>
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>
            <ConfirmDialog :ref="confirmDialogRef" :body="$t(confirmDialogText)" :yesText="$t('Да')" :noText="$t('Нет')" :width="550" />
            <ConfirmDialog
                :ref="confirmLeaveRef"
                :body="$t('Данные не загружены в биллинговую систему ALSECO Heat. Вы действительно хотите покинуть страницу?')"
                :yesText="$t('Да')"
                :noText="$t('Нет')"
                :width="550"
            />
            <v-card class="mb-7" flat>
                <v-tabs v-model="tab" background-color="transparent" color="white" dark>
                    <v-tabs-slider color="#00638a"></v-tabs-slider>
                    <v-tab
                        v-for="item in tabs"
                        :key="item.tab"
                        :class="{ smallTab: $vuetify.breakpoint.xsOnly, smallTab2: $vuetify.breakpoint.xsOnly && item.isSmaller }"
                        >{{ item.tab }}</v-tab
                    >
                </v-tabs>

                <v-tabs-items v-model="tab">
                    <!-- Основная информация -->
                    <v-tab-item>
                        <v-card class="px-0">
                            <GeneralInfo :item="uploadsDetailTranslated" />
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <v-card class="px-0">
                            <PreviewFile :id="this.$route.params.id" :status="status" />
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <v-card class="px-0">
                            <GroupedData :id="this.$route.params.id" :status="status" />
                        </v-card>
                    </v-tab-item>
                    <v-tab-item v-if="status === 'Принят' || status === 'Принят частично'">
                        <v-card class="px-0">
                            <FactData :id="this.$route.params.id" />
                        </v-card>
                    </v-tab-item>
                </v-tabs-items>
            </v-card>
        </div>
    </div>
</template>

<script>
import GeneralInfo from '@/components/servorgs/uploads/uploadsDetail/GeneralInfo';
import PreviewFile from '@/components/servorgs/uploads/uploadsDetail/PreviewFile';
import GroupedData from '@/components/servorgs/uploads/uploadsDetail/GroupedData';
import FactData from '@/components/servorgs/uploads/uploadsDetail/FactData';
import PageLabel from '@/components/ui/PageLabel';
import ConfirmDialog from '@/components/ui/ConfirmDialog';

import translate from '@/utils/translate.util';
import ErrorCellValidator from '@/mixins/ErrorCellValidator';
import { mapActions, mapState } from 'vuex';

export default {
    components: { GeneralInfo, PreviewFile, GroupedData, FactData, ConfirmDialog, PageLabel },
    mixins: [ErrorCellValidator],
    data: () => ({
        confirmDialogRef: 'confirmDialogRef',
        confirmLeaveRef: 'confirmLeaveRef',
        uploadsDetail: null,
        tab: 0,
        confirmDialogText: null
    }),
    async mounted() {
        await this.getDetails();
        await this.getGroupedData(this.$route.params.id);
    },
    computed: {
        ...mapState('permissions', ['userPermissions']),
        ...mapState('uploads', ['groupedData', 'fileDetail', 'status']),
        uploadsDetailTranslated() {
            return translate(this.fileDetail, 'full', this.$i18n.locale);
        },
        loggedIn() {
            return this.$store.getters['auth/loggedIn'];
        },
        isUploadButtonActive() {
            // кнопка "Отправить в обработку" будет активна только, если будет хотя бы одна запись в таблице "Предварительный просмотр данных"
            if (this.groupedData && this.groupedData.length && Array.isArray(this.groupedData)) {
                return this.groupedData.some(item => item.error_text === '');
            } else {
                return false;
            }
        },
        previewDataFilter: {
            get() {
                return this.$store.state.uploads.uploadsListFilter;
            },
            set(val) {
                this.$store.commit('uploads/setUploadsListFilter', val);
            }
        },
        tabs() {
            const tabs = [
                { tab: this.$t('Общие сведения'), content: 'Основная информация текст', isSmaller: true },
                { tab: this.$t('Предварительный просмотр файла'), content: 'Платежи текст', isSmaller: false },
                { tab: this.$t('Предварительный просмотр данных'), content: 'Недоимки/Задолженность', isSmaller: false },
                { tab: this.$t('Присоединенные данные'), onlyIf: ['Принят', 'Принят частично'], content: 'Недоимки/Задолженность', isSmaller: false }
            ];
            return tabs.filter(item => {
                if (item.onlyIf && item.onlyIf.includes(this.status)) {
                    return item;
                } else {
                    return !item.onlyIf;
                }
            });
        }
    },
    methods: {
        ...mapActions('base', ['showMessage']),
        ...mapActions('uploads', ['getFileDetail', 'confirmUpload', 'cancelUpload', 'getGroupedData']),

        async getDetails() {
            await this.getFileDetail(this.$route.params.id);
        },

        async sendToProcess() {
            this.confirmDialogText = 'Отправить файл в обработку?';
            const answer = await this.$refs[this.confirmDialogRef].show();
            if (!answer) return;
            let response = await this.confirmUpload(this.$route.params.id);

            if (response.successfull) {
                await this.getDetails();
                this.$router.push({ name: 'UploadsList' });
                setTimeout(() => {
                    this.showMessage({ color: 'warning', message: 'Файл обрабатывается' });
                }, 500);
            }
        },
        clearTables() {
            this.$store.commit('uploads/setPreviewDataPagination', { page: 1 });
            this.$store.commit('uploads/setPreviewDataUnformattedFilter', {});
            this.$store.commit('uploads/setGroupedDataUnformattedFilter', {});
            this.$store.commit('uploads/setFactDataUnformattedFilter', {});
        },
        async cancelUploading() {
            this.confirmDialogText = 'Вы хотите отменить загрузку файла? Данные не будут переданы в биллинговую систему ALSECO Heat';
            const answer = await this.$refs[this.confirmDialogRef].show();
            if (!answer) return;
            let response = await this.cancelUpload(this.$route.params.id);
            if (response.successfull) {
                await this.getDetails();
                this.$router.push({ name: 'UploadsList' });
                setTimeout(() => {
                    this.showMessage({ color: 'warning', message: this.$t('Загрузка файла отменена') });
                }, 500);
            }
        }
    },
    async beforeRouteLeave(to, from, next) {
        this.$store.commit('uploads/setPreviewDataFilter', null);
        this.$store.commit('uploads/setGroupedDataFilter', null);
        this.$store.commit('uploads/setFactDataFilter', null);

        if (to.name !== 'UploadsList') {
            this.previewDataFilter = {};
            this.$store.commit('uploads/setFilter', null);
        }

        if (this.status === 'Загружен' && this.loggedIn) {
            const answer = await this.$refs[this.confirmLeaveRef].show();
            if (answer) {
                this.clearTables();
                next();
            } else {
                next(false);
            }
        } else {
            this.clearTables();
            next();
        }
    }
};
</script>

<style lang="scss">
.v-tabs .v-item-group {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
}
.v-tabs .v-item-group {
    .v-slide-group__prev,
    .v-slide-group__prev {
        display: none !important;
    }
    .v-slide-group__wrapper .v-slide-group__content .v-tab {
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        margin-right: 0.1em;
        letter-spacing: 0.0392857143em;
        background-color: #363e59;
        color: white;
        height: 46px;

        &--active {
            height: 48px;
            background-color: #00638a;
        }
    }
}
.v-window {
    &-item > .v-card {
        padding: 0.5em 0em;
    }
}
</style>
